// @ts-nocheck
import SceneLayer from "./layer";

export default class SceneLayerTile extends SceneLayer {
	/**
	 * Vytvoreni vrstvy pro dlazdice.
	 *
	 * @param  {String|Number} id Volitelne ID
	 * @param  {String} url URL pro tahani dlazdic
	 * @param  {Object} [options] Volitelny objekt pro nastaveni vrstvy
	 */
	constructor(scene, itemId, id?, url?, options?) {
		super(scene, itemId, id);

		this._url = url || "";
		this._options = options || {};
		this._angle = 0;
		this._isMapset = false;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerTile",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.url = this._url;
		rd.options = this._options;
		rd.isMapset = this._isMapset;

		return rd;
	}

	/**
	 * Nastaveni vrstvy.
	 */
	setOptions(...args) {
		const options = args[0];

		for (const param in options) {
			if (param in options) {
				this._options[param] = options[param];
			}
		}

		this._onChange(this._scene.featureEvent("layerTileSetOptions", true, true), args);
	}

	/**
	 * Nastaveni URL vrstvy.
	 */
	setURL(...args) {
		this._url = args[0];

		this._onChange(this._scene.featureEvent("layerTileSetUrl", true, true), args);
	}

	/**
	 * Rotace vrstvy o zadany pocet uhlu.
	 *
	 * @param  {Number} angle Uhel ve stupnich
	 */
	rotateTo(...args) {
		this._angle = args[0];

		this._onChange(this._scene.featureEvent("layerTileRotateTo", true, true), args);
	}

	/**
	 * Ziskani url vrstvy.
	 *
	 * @return {String}
	 */
	getURL() {
		return this._url || "";
	}

	/**
	 * Nastaveni priznaku, ze se jedna o mapset.
	 */
	setMapset() {
		this._isMapset = true;
	}

	/**
	 * Staticka metoda - ziskani defaultni konfigurace.
	 *
	 * @return {Object}
	 * @static
	 */
	static getTileOptions() {
		return {
			tileSize: 256,
			alpha: false,
			fadeTime: 600,
			query: "{zoom}-{x}-{y}",
		};
	}
}
